import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

const HeroSection: React.FC = () => {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimal%20abstract%20background%20with%20soft%20golden%20and%20amber%20gradients%2C%20flowing%20silk-like%20textures%2C%20luxurious%20warm%20atmosphere%2C%20clean%20modern%20design%2C%20no%20text%20or%20objects%2C%20subtle%20elegant%20pattern&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="福利铺子首页背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>
      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 tracking-wide">
          海量福利优惠<span className="text-accent-400">一站汇聚</span>
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
          福利铺子每天精选海量福利资源，涵盖购物返现、限时秒杀、会员特权等，让您轻松享受实实在在的省钱福利。关注福利铺子，好福利不错过！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/xianshi-miaosha"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-all whitespace-nowrap cursor-pointer"
          >
            立即探索福利
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/20 hover:bg-white/30 backdrop-blur-sm text-white rounded-full font-medium text-sm transition-all whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;